/**
 * web-studio-sites D7: what Waiting on you's current state requires a drawing
 * to show: each held booking, form and payment, opening it (named in
 * `data-item` by its address), and View forms while three or more are folded.
 */
import type { RequiredPart, RequiredParts } from '../../contract/required';
import type { WaitingOnYouState } from './contract';

export const requiredParts: RequiredParts<WaitingOnYouState> = (state) => {
  if (state.empty) return [];
  const open =
    (part: string) =>
    (row: { readonly href: string }): RequiredPart => ({ part, item: row.href, action: 'open' });
  return [
    ...state.held.map(open('held')),
    ...(state.summary && !state.formsOpen ? [{ part: 'viewForms', action: 'openForms' }] : []),
    ...state.forms.map(open('form')),
    ...state.payments.map(open('payment')),
  ];
};
